import React from 'react'
import './ProductWithAvatar.sass'
import NoAvatar from '../../../../../ui/NoAvatar/NoAvatar'
function ProductWithAvatar({ id, avatar, name = 'test name', description }) {
  return (
    <div className="ProductWithAvatar">
      {avatar ? (
        <img
          src={`https://storage.googleapis.com/amecos.firebasestorage.app/products/${id}/thumbs/${avatar.fileName}_300x300.webp`}
          alt={name}
        />
      ) : (
        <NoAvatar />
      )}
      <div className="Content">
        <p className="Title">{name}</p>
        <p className="Description">{description}</p>
      </div>
    </div>
  )
}

export default ProductWithAvatar
